var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFcaRegulatedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Container"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4.58333,
    fill: "#AEC2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.7714 5.26725C12.2688 5.26725 13.4832 6.48085 13.4833 7.97819V10.7399H14.8046C15.1082 10.74 15.3552 10.9861 15.3554 11.2897V15.6901C15.3551 15.9936 15.1082 16.2399 14.8046 16.2399H6.7382C6.43468 16.2398 6.18864 15.9936 6.1884 15.6901V11.2897C6.18856 10.9862 6.43464 10.74 6.7382 10.7399H8.06047V7.97819C8.06059 6.48095 9.27417 5.26742 10.7714 5.26725ZM10.7714 6.36686C9.88169 6.36703 9.1602 7.08847 9.16007 7.97819V10.7399H9.85539C10.159 10.7401 10.4052 10.986 10.4052 11.2897V13.1178C10.4055 13.32 10.5692 13.4849 10.7714 13.485C10.9737 13.485 11.1373 13.32 11.1376 13.1178V11.2897C11.1376 10.986 11.3837 10.74 11.6874 10.7399H12.3827V7.97819C12.3826 7.08836 11.6613 6.36686 10.7714 6.36686Z",
    fill: "#1F0713"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcaRegulatedIcon);
export default __webpack_public_path__ + "static/media/fca-regulated-icon.52d86ab254920be0e34a17eab8769fc6.svg";
export { ForwardRef as ReactComponent };